// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// utility
import _ from 'lodash';
import { push } from 'react-router-redux';
import Pager from 'rc-pager';
import cx from 'classnames';

import PreviousIcon from '../../../../../../common/svgs/PreviousIcon';
import NextIcon from '../../../../../../common/svgs/NextIcon';

import DropDownMenu from '../../../../../../common/components/SimpleDropDownMenu';
import prettyPhone from '../../../../../../lib/prettyPhone';
import ChevronIcon from '../../../../../../common/svgs/ChevronIcon';

// lib
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

class CompaniesTable extends Component {
  static propTypes = {
    companies: PropTypes.object,
    total: PropTypes.any,
    staticData: PropTypes.object,
    dispatch: PropTypes.func,
    onPageChange: PropTypes.func,
    onFilterChange: PropTypes.func,
    onSortChange: PropTypes.func,
    filters: PropTypes.object,
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    labels: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
    this.companyStatusList = _.keyBy(this.props.staticData.companyStatus, 'id');
    this.salesPartners = _.keyBy(this.props.staticData.salesPartners, 'id');

    const initialState = {
      relationshipManagers: this.props.staticData.relationshipManagers,
      clientAdvisers: this.props.staticData.clientAdvisers,
    };

    this.state = initialState;
  }

  flipColumn(column) {
    const order = this.props.filters.by === column && this.props.filters.order === 'asc' ? 'desc' : 'asc';

    if (this.props.onSortChange) {
      this.props.onSortChange({by: column, order});
    }
  }

  showDashboard = (event, companyId) => {
      this.props.dispatch(push(`/admin/companies/${companyId}/details`));
  };
  showCard = (event, companyId) => {
      this.props.dispatch(push(`/admin/companies/?card=${companyId}`));
  };

  generateMenuItems(staticData, type, hideAny) {
    const object = staticData[type];

    const menuItems = _.map(object, (item) => {
      return {
        value: item.id || item.value,
        primaryText: (item.name || item.primaryText)
      };
    });

    if (hideAny) {
      return menuItems;
    }
    else {
      return _.concat({value: -1, primaryText: 'All'}, menuItems);
    }
  }

  handleSkip(currentPage) {
    if (this.props.onPageChange) this.props.onPageChange(currentPage);
  }

  handleFilterDefaultValues(filterName) {
    return _.get(this.props.filters, filterName, -1);
  }

  render() {
    const {
      companies,
      staticData,
      labels,
    } = this.props;

    let currentCount = this.props.pageSize * (this.props.currentPage + 1);
    currentCount = (currentCount < this.props.total) ? currentCount : this.props.total;

    const companiesComponentArr =  _(companies)
          .map((row, index) => {
            const status = this.companyStatusList[row.companyStatus];
            const salesPartner = _.get(this.salesPartners, `${row.salesPartner}.name`);
            const firmTypes = _(staticData.industryTypesList).reduce((prev, curr) => {
                if (row.industryTypes && !!~row.industryTypes.indexOf(curr.id)) {
                  prev.push(curr.name);
                }
                return prev;
              }, []).join(', ');
            return (
            <TableRow className='company-row' key={`${row.id}-${row.name}`} data-id={`${row.id}-${row.name}`}>
              <TableRowColumn className='table-col name'>
                <div className='expand-icon' onClick={(event) => this.showCard(event, row.id)}/>
                <div className='company-name' onClick={(event) => this.showDashboard(event, row.id)}>{row.name}</div>
              </TableRowColumn>
              <TableRowColumn className='table-col status' style={{width: '250px'}}>
                <div className='status-circle' data-id='Status Icon' style={{backgroundColor: status.color, borderColor: status.color}}></div>{status.name}
              </TableRowColumn>
              <TableRowColumn className='table-col phone' style={{width: '250px'}}>
                {!!row.phoneNumber && prettyPhone(row.phoneNumber)}
              </TableRowColumn>
              <TableRowColumn className='table-col firm-type'>
                {firmTypes}
              </TableRowColumn>
              <TableRowColumn className='table-col sales-partner'>
                {salesPartner}
              </TableRowColumn>
            </TableRow>);
          })
          .value();

    return (
      <li className='applicants-column company-table company-dashboard-table' data-id='company-list'>
        <header className='header-container'>

          <DropDownMenu
            onChange={ this.props.onFilterChange('statuses') }
            data-id='status-dropdown'
            floatingLabelText='Status'
            defaultValue={this.handleFilterDefaultValues('statuses')}
            className='dropdown-filter status-dropdown'
            menuItems={ this.generateMenuItems(this.props.staticData, 'companyStatus') }
          />

          <DropDownMenu
            className='industry-types'
            data-id='Firm Types Filter'
            floatingLabelText={labels.filterLabels.firmTypesFilter}
            defaultValue={this.handleFilterDefaultValues('industryTypes')}
            onChange={this.props.onFilterChange('industryTypes')}
            menuItems={_.concat({primaryText: 'All', value: -1}, this.props.staticData.industryTypesList)}
          />

          <DropDownMenu
            className='relationship-manager'
            data-id='Relationship Manager Filter'
            floatingLabelText='Relationship Manager'
            defaultValue={this.handleFilterDefaultValues('relationshipManagerId')}
            onChange={this.props.onFilterChange('relationshipManagerId')}
            menuItems={_.concat([{primaryText: 'All', value: -1}, {primaryText: 'Unassigned', value: 0}],
              this.state.relationshipManagers.map(rm => _.assign({primaryText: `${rm.firstName} ${rm.lastName}`, value: rm.employeeId}))
            )}
          />

          { labels.filters.showState &&
            <DropDownMenu
              className='state'
              data-id='State'
              floatingLabelText='State'
              defaultValue={this.handleFilterDefaultValues('state')}
              onChange={this.props.onFilterChange('state')}
              menuItems={_.concat({primaryText: 'All', value: -1}, this.props.staticData.stateList)}
            />
          }

          { labels.filters.showIiaba &&
            <DropDownMenu
              className='iiaba-state'
              data-id='IIABA State'
              floatingLabelText='IIABA State'
              defaultValue={this.handleFilterDefaultValues('iiabaState')}
              onChange={this.props.onFilterChange('iiabaState')}
              menuItems={_.concat({primaryText: 'All', value: -1}, this.props.staticData.iiabaStates.map(state => _.assign({primaryText: state.name, value: state.id})))}
            />
          }

        </header>
        <div className='pager-wrapper'>
          <div className='pager-info'>Showing <span className='count'>{currentCount}</span> of <span className='count'>{this.props.total}</span></div>
            <Pager
              total={Math.ceil(this.props.total / this.props.pageSize)}
              current={this.props.currentPage}
              onSkipTo={::this.handleSkip}
              previousLabel={<div className='prev'><PreviousIcon/> PREV</div>}
              nextLabel={<div className='next'>NEXT <NextIcon/></div>}
            />
        </div>
        <Table
          selectable={false}
          multiSelectable={false}
          className='table-companies'
          fixedHeader
          height={'calc(100vh - 223px)'} // It will not work if moves to CSS.
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn className='table-col name'>Company Name</TableHeaderColumn>
              <TableHeaderColumn className='table-col status' style={{width: '250px'}}>Status</TableHeaderColumn>
              <TableHeaderColumn className='table-col phone' style={{width: '250px'}}>Phone #</TableHeaderColumn>
              <TableHeaderColumn className='table-col firm-type'>{labels.tableRowHeaders.firmType}</TableHeaderColumn>
              <TableHeaderColumn className='table-col sales-partner'>
                <div onClick={ (e) => this.flipColumn('salesPartner') }>
                  Sales Partner
                  <span className={cx('wv-chevron',
                    {active: this.props.filters && this.props.filters.by === 'salesPartner'},
                    {flipped: this.props.filters && this.props.filters.by === 'salesPartner' && this.props.filters.order !== 'desc'})} >
                    <ChevronIcon/>
                  </span>
                </div>
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
          >
            {companiesComponentArr}
          </TableBody>
        </Table>
      </li>
    );
  }
}


export default CompaniesTable;



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Dashboard/CompanyManager/CompaniesTable/index.js